class Numbers {
    static path = 'values/number';

    constructor(mutator){
        this.addOutput("value", "number");
        this.addProperty("value", 1.0);
        this.widget = this.addWidget("number","value",1,"value");
        this.widgets_up = true;
        this.bgcolor = '#bfb5b2';
        this.title = 'Static Number';
        this.desc = 'Constant number';
    }

    onExecute() {
        this.setOutputData(0, parseFloat(this.properties["value"]));
    }

    getTitle() {
        if (this.flags.collapsed) {
            return this.properties.value;
        }
        return this.title;
    }

    setValue(v) {
        this.setProperty("value",v);
        this.outputs[0].type = this.isInteger(v) ? 'integer,number' : 'number';
    }

    onDrawBackground() {
        //show the current value
        this.outputs[0].label = this.properties["value"].toFixed(3);
    }


    isInteger(num) {
        return Number.isInteger(num);
    }
}

module.exports = Numbers
